module.exports = __webpack_public_path__ + "res/7-img_card_bg.59ba6de7968819d83e32351c9db0f92f.png";